export enum CampusTableColumn {
  CLAVE = 'Clave',
  NOMBRE = 'Nombre',
  ESTATUS = 'Estatus',
}
